import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Main = () => {
  const userId = sessionStorage.getItem("userId");
  const [formData, setFormData] = useState({
    old_password: "",
    password: "",
    password_confirmation: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
 const navigate = useNavigate();
  const handleRegistration = async (event) => {
    event.preventDefault();

    // **Validation**
    if (!formData.old_password) {
      toast.error("Old password is required.");
      return;
    }
    if (!formData.password) {
      toast.error("New password is required.");
      return;
    }
    if (formData.password.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    if (formData.password !== formData.password_confirmation) {
      toast.error("Passwords do not match.");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("old_password", formData.old_password);
    formDataToSend.append("password", formData.password);
    formDataToSend.append("password_confirmation", formData.password_confirmation);

    try {
      const response = await axios.post(
        `https://ecom.testingwebsitelink.com/api/update-password/${userId}`,
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log("Password change response:", response.data);
      toast.success("Password changed successfully.");
      navigate("/");
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error("Failed to change password. Please try again.");
    }
  };

  return (
    <>
      <form className="Auth-form" onSubmit={handleRegistration}>
        <h3 className="Auth-form-title">CHANGE PASSWORD</h3>
        <div className="Auth-form-content">
          <div className="form-group mt-3">
            <label>Old Password</label>
            <input
              type="password"
              name="old_password"
              value={formData.old_password}
              onChange={handleChange}
              className="form-control mt-1"
              placeholder="********"
              required
            />
          </div>
          <div className="form-group mt-3">
            <label>New Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-control mt-1"
              placeholder="********"
              required
            />
          </div>
          <div className="form-group mt-3">
            <label>Confirm Password</label>
            <input
              type="password"
              name="password_confirmation"
              className="form-control mt-1"
              placeholder="********"
              value={formData.password_confirmation}
              onChange={handleChange}
              required
            />
          </div>
          <div className="d-grid gap-2 mt-3">
            <button type="submit" className="btn btn-color-login">
              Change Password
            </button>
          </div>
          <div className="text-center">
            <Link className="login-link-color" to="/">
              RETURN TO WEBSITE
            </Link>
          </div>
        </div>
      </form>
    </>
  );
};

export default Main;
